import { render, staticRenderFns } from "./biller-nav.vue?vue&type=template&id=37f5a157&"
import script from "./biller-nav.vue?vue&type=script&lang=js&"
export * from "./biller-nav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports